import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { useDispatch } from 'react-redux'

interface ShipmentsState {
  selectedWheatCode: string | null
  showDiscarded: boolean
  showStorage: boolean
}

const initialState: ShipmentsState = {
  selectedWheatCode: null,
  showDiscarded: false,
  showStorage: false,
}

const shipmentsSlice = createSlice({
  name: 'shipments',
  initialState,
  reducers: {
    setSelectedWheatCode: (state, action: PayloadAction<string>) => {
      state.selectedWheatCode = action.payload
    },
    clearSelectedWheatCode: (state) => {
      state.selectedWheatCode = null
    },
    setShowDiscarded: (state, action) => {
      state.showDiscarded = action.payload
    },
    setShowStorage: (state, action) => {
      state.showStorage = action.payload
    },
  },
})

export const {
  setSelectedWheatCode,
  clearSelectedWheatCode,
  setShowDiscarded,
  setShowStorage,
} = shipmentsSlice.actions

export default shipmentsSlice.reducer

export const useSetShowDiscarded = () => {
  const dispatch = useDispatch()

  return (value: boolean) => {
    dispatch(setShowDiscarded(value))
  }
}

export const useSetShowStorage = () => {
  const dispatch = useDispatch()

  return (value: boolean) => {
    dispatch(setShowStorage(value))
  }
}
